// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("UserSubscription", {
  userId: __t.u64(),
  vipTierId: __t.u32(),
  stripeSubscriptionId: __t.string(),
  stripeCustomerId: __t.string(),
  status: __t.string(),
  currentPeriodStart: __t.u64(),
  currentPeriodEnd: __t.u64(),
  coinBonusGrantedAt: __t.u64(),
  createdAt: __t.u64(),
  updatedAt: __t.u64(),
});


